import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from './Header';
import { Footer } from './Footer';

/* The v5 pages (home, artist pages, artist interview) bring their own neon nav + footer,
   so they render without the classic Header/Footer. Every other route keeps the classic layout. */
const isV5Route = (pathname: string) => pathname === '/' || pathname.startsWith('/artist/') || pathname === '/artist-interview';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const toaster = <Toaster theme="dark" position="bottom-right" toastOptions={{
    style: {
      borderRadius: 0,
      background: '#161616',
      border: '1px solid #3a3a3a'
    }
  }} data-id="element-148" data-mp="3f2cbgfx83930" />;
  if (isV5Route(pathname)) {
    return <>
        <Outlet data-id="element-149" data-mp="1kpmiq1ilc5x7" />
        {toaster}
      </>;
  }
  return <div className="flex min-h-screen w-full flex-col bg-ink text-white" data-id="element-150" data-mp="1oq6diyfoyxg6">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-white focus:px-4 focus:py-2 focus:text-ink" data-id="element-151" data-mp="3n1bqsr5biucu">
        Skip to content
      </a>
      <Header data-id="element-152" data-mp="3dah2lh8ihkor" />
      <main id="main" className="flex-1" data-id="element-153" data-mp="3da793jo9cveb">
        <Outlet data-id="element-154" data-mp="3d8w8ttu0u5ry" />
      </main>
      <Footer showQuickLinks={pathname !== '/'} data-id="element-155" data-mp="38c5v3d5ovm9p" />
      {toaster}
    </div>;
}